<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <h2>Enviar archivo</h2>
            <div
                :style="`width: 360px; height: ${0 + (33 * files.length)}px; max-height: 132px; overflow-y: auto; padding: 0px 10px 0px 10px; margin: 10px 0 10px 0; transition: 0.5s`">
                <div v-for="archivo in files" :key="archivo.file.name"
                    :class="`documento ${archivo.tipo} ${archivo.tipo == 'error' ? 'apply-shake' : ''}`">
                    <font-awesome-icon v-if="archivo.icon != 'loading'" :icon="getIconPath(archivo.file.name)" />
                    <i v-else class="el-icon-loading"></i>
                    {{ archivo.file.name }}
                </div>
            </div>
            <h2>Opciones de documento</h2>
            <ul class="contenedoraplicaciones">
                <li @click="cargarNomina('dividir')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/flechas.png" width="70%" />
                        </div>
                        <p>Dividir documento</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Escanea un PDF con todas las nóminas y las separa y reparte
                        individualmente.</span>
                </li>
                <li @click="cargarNomina('zip')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/archivo-zip.png" width="70%" />
                        </div>
                        <p>Extraer ZIP</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Extrae un ZIP con todas las nóminas y las reparte
                        individualmente.</span>
                </li>
                <li @click="cargarNomina('individual')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/pdf.png" width="70%" />
                        </div>
                        <p>Individual</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Carga una sola nómina y se repartirá a quien figure en ella.</span>
                </li>
            </ul>
            <div style="display:flex;">
                <el-button type="primary" icon="Back" @click="$router.go(-1)" :disabled="leftDisabled" />
            </div>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'

export default {
    name: 'EnviarNominas',
    watch: {
    },
    data() {
        return {
            loading: false,
            router: this.$router,
            working: process.env.VUE_APP_WORKING,
        }
    },
    mounted() {

    },
    computed: mapState([
        'datosemp', 'receptores', 'configEnvio', 'params', 'files'
    ]),
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setConfigEnvio',
            'setContent',
            'setPubTitulo',
            'setFiles'
        ]),
        async cargarNomina(accion) {
            const formData = new FormData();
            this.files.forEach((file, index) => {
                file.tipo = "secondary";
                file.icon = "loading";
                formData.append('file' + index, file.file);
                formData.append('accion', accion);
            })
            let resp = await fetch(process.env.VUE_APP_PORTAL + '/api/nominas/enviarNominas', {
                method: 'POST',
                body: formData
            })
            if (resp.status == 200) {
                this.$notify({
                    title: '¡Bien!',
                    message: 'Nóminas procesadas correctamente',
                    type: 'success'
                });
                this.setFiles([])
                this.$router.push('/dashboard')
            } else {
                this.$notify({
                    title: 'Oops',
                    message: 'Ha ocurrido un error procesando las nóminas',
                    type: 'error'
                });
            }

        },
        getIconPath(nombreArchivo) {
            let img = '';
            let ext = nombreArchivo.split('.').pop();
            switch (ext) {
                case 'ico':
                case 'gif':
                case 'jpg':
                case 'jpeg':
                case 'jpc':
                case 'jp2':
                case 'jpx':
                case 'xbm':
                case 'wbmp':
                case 'png':
                case 'bmp':
                case 'tif':
                case 'tiff':
                case 'webp':
                case 'avif':
                case 'svg':
                    img = 'fa-regular fa-image';
                    break;
                case 'passwd':
                case 'ftpquota':
                case 'sql':
                case 'js':
                case 'json':
                case 'sh':
                case 'config':
                case 'twig':
                case 'tpl':
                case 'md':
                case 'gitignore':
                case 'c':
                case 'cpp':
                case 'cs':
                case 'py':
                case 'rs':
                case 'map':
                case 'lock':
                case 'dtd':
                    img = 'fa-regular fa-file-code';
                    break;
                case 'txt':
                case 'ini':
                case 'conf':
                case 'log':
                case 'htaccess':
                case 'yaml':
                case 'yml':
                case 'toml':
                    img = 'fa-regular fa-file-lines';
                    break;
                case 'css':
                case 'less':
                case 'sass':
                case 'scss':
                    img = 'fa-brands fa-css3-alt';
                    break;
                case 'bz2':
                case 'zip':
                case 'rar':
                case 'gz':
                case 'tar':
                case '7z':
                case 'xz':
                    img = 'fa-regular fa-file-zipper';
                    break;
                case 'php':
                case 'php4':
                case 'php5':
                case 'phps':
                case 'phtml':
                    img = 'fa-solid fa-code';
                    break;
                case 'htm':
                case 'html':
                case 'shtml':
                case 'xhtml':
                    img = 'fa-brands fa-html5';
                    break;
                case 'xml':
                case 'xsl':
                    img = 'fa-regular fa-file-excel';
                    break;
                case 'wav':
                case 'mp3':
                case 'mp2':
                case 'm4a':
                case 'aac':
                case 'ogg':
                case 'oga':
                case 'wma':
                case 'mka':
                case 'flac':
                case 'ac3':
                case 'tds':
                    img = 'fa-solid fa-music';
                    break;
                case 'm3u':
                case 'm3u8':
                case 'pls':
                case 'cue':
                case 'xspf':
                    img = 'fa-solid fa-headphones';
                    break;
                case 'avi':
                case 'mpg':
                case 'mpeg':
                case 'mp4':
                case 'm4v':
                case 'flv':
                case 'f4v':
                case 'ogm':
                case 'ogv':
                case 'mov':
                case 'mkv':
                case '3gp':
                case 'asf':
                case 'wmv':
                case 'webm':
                    img = 'fa-regular fa-file-video';
                    break;
                case 'eml':
                case 'msg':
                    img = 'fa-regular fa-envelope';
                    break;
                case 'xls':
                case 'xlsx':
                case 'ods':
                    img = 'fa-regular fa-file-excel';
                    break;
                case 'csv':
                    img = 'fa-regular fa-file-lines';
                    break;
                case 'bak':
                case 'swp':
                    img = 'fa-regular fa-clipboard';
                    break;
                case 'doc':
                case 'docx':
                case 'odt':
                    img = 'fa-regular fa-file-word';
                    break;
                case 'ppt':
                case 'pptx':
                    img = 'fa-regular fa-file-powerpoint';
                    break;
                case 'ttf':
                case 'ttc':
                case 'otf':
                case 'woff':
                case 'woff2':
                case 'eot':
                case 'fon':
                    img = 'fa-solid fa-font';
                    break;
                case 'pdf':
                    img = 'fa-regular fa-file-pdf';
                    break;
                case 'psd':
                case 'ai':
                case 'eps':
                case 'fla':
                case 'swf':
                    img = 'fa-regular fa-file-image';
                    break;
                case 'exe':
                case 'msi':
                    img = 'fa-regular fa-file';
                    break;
                case 'bat':
                    img = 'fa-solid fa-terminal';
                    break;
                default:
                    img = 'fa-solid fa-circle-info';
                    break;
            }
            return img;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }

    .contenedoraplicaciones {
        width: calc(100% - 5px);
        list-style: none;
        padding-inline-start: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 2.5px;

        @media(max-width: 1500px) {
            flex-direction: column;
        }

        li {
            @media(max-width: 1500px) {
                flex-basis: calc(50% - 20px);
            }

            @media(min-width: 1500px) {
                flex-basis: calc(33.33% - 20px);
                aspect-ratio: 2/1;
            }

            /* Ajusta este valor según tus necesidades */
            box-sizing: border-box;

            div {
                display: flex;
                align-items: center;
                text-align: left;
            }

            p {
                margin: 0px;
            }
        }
    }


    .tipodocumento {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        padding: 10px;
        border: 2px solid #a9a9a929;
        margin-bottom: 10px;
        border-radius: 10px;
        font-weight: bold;
        transition: 0.5s;
        justify-content: flex-start;

        &:hover {
            background-color: #a9a9a929;
            border-color: #a9a9a929;
        }

        .icono {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #0985e325;
            border-radius: 10px;
            margin-right: 10px;
        }

        .iconoconsulta {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #1abc9c;
            border-radius: 10px;
            margin-right: 10px;
        }
    }
}
</style>